import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { createExtension, ICreateExtensionRequest, IExtension } from 'src/api/extensions';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from 'src/constants/QueryKeys';

interface ICreateExtensionParams {
  brandId: string;
  payload: ICreateExtensionRequest;
}

export const useCreateExtension = (onSuccess?: (data: IExtension) => void) => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ brandId, payload }: ICreateExtensionParams) => createExtension(brandId, payload),
    onSuccess: (data: IExtension, variables) => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.EXTENSIONS, variables.brandId] });
      showSnackbar({
        status: SnackbarStatus.SUCCESS,
        message: `${data.addon.name} has been connected.`,
      });
      onSuccess?.(data);
    },
    onError: (error: Error) => {
      showSnackbar({
        message: error.message || 'Unable to connect extension',
        status: SnackbarStatus.ERROR,
      });
      captureException(error);
    },
  });
};
